<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner-list">
    <div class="row mb-4">
      <div class="col-md-8">
        <div class="title-wrapper">
          <div>
            <h1 class="title-default">Instituições para conciliação</h1>
            <p class="welcome-message">
              Visualize os lançamentos pendentes por banco ou acesse o histórico geral de transações
              integradas.
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-4 header-actions">
        <button type="button" mat-flat-button class="btn-primary" (click)="atualizarLista()">
          <mat-icon>refresh</mat-icon>
          Recarregar Contas
        </button>
      </div>
    </div>

    @if (isLoading) {
    <div class="contas-grid">
      @for (i of [1,2,3,4]; track i) {
      <div class="banco-card banco-card-skeleton">
        <app-loading-box height="64" width="64" margin="0"></app-loading-box>
        <div class="banco-card-info">
          <app-loading-box height="16" width="160" margin="0 0 6px 0"></app-loading-box>
          <app-loading-box height="13" width="220" margin="0 0 4px 0"></app-loading-box>
          <app-loading-box height="12" width="140" margin="0"></app-loading-box>
        </div>
        <div class="banco-card-status">
          <app-loading-box height="24" width="80" margin="0"></app-loading-box>
        </div>
      </div>
      }
    </div>
    }

    @if (!isLoading) {
    @if (_contas.length === 0) {
    <app-empty-list mensagem="Nenhuma conta bancária cadastrada."
      descricao="Adicione uma conta bancária para começar a conciliar seus lançamentos.">
    </app-empty-list>
    }
    @if (_contas.length > 0) {
    <div class="section-title">
      <mat-icon>account_balance</mat-icon>
      <span>Contas Bancárias</span>
    </div>
    <div class="contas-grid">
      @for (conta of contasBancarias; track conta.idContaFinanceira) {
      <div class="banco-card" (click)="navegarParaLancamentos(conta)">
        <div class="banco-card-logo">
          @if (conta.urlLogoBanco) {
          <img [src]="conta.urlLogoBanco" [alt]="conta.nomeBanco" class="logo-img" />
          }
          @if (!conta.urlLogoBanco) {
          <div class="logo-placeholder">
            {{ conta.nomeBanco.charAt(0) }}
          </div>
          }
        </div>
        <div class="banco-card-info">
          <span class="banco-nome">{{ conta.nomeBanco }}</span>
          <span class="conta-descricao">{{ conta.descricao }}</span>
          <span class="conta-agencia">Ag. {{ conta.agencia }} • CC {{ conta.numeroConta }}</span>
          @if (getStatusIntegracaoExtrato(conta) === 'conectado') {
          <span class="status-badge badge-verde mt-2">● Conectado</span>
          }
          @if (getStatusIntegracaoExtrato(conta) === 'conectando') {
          <span class="status-badge badge-amarelo mt-2">● Conectando</span>
          }
          @if (getStatusIntegracaoExtrato(conta) === 'disponivel') {
          <span class="status-badge badge-cinza mt-2">Integração disponível</span>
          <button mat-stroked-button class="btn-secondary btn-configurar-integracao mt-3"
            (click)="irParaConfiguracaoIntegracao(conta, $event)">
            Configurar integração
          </button>
          }
        </div>
        <div class="banco-card-status">
          @if (conta.totalPendentes > 0) {
          <span class="status-badge badge-vermelho">
            {{ conta.totalPendentes }} Pendente{{ conta.totalPendentes !== 1 ? 's' : '' }}
          </span>
          }
          @if (conta.totalPendentes === 0) {
          <span class="status-badge badge-cinza"> 0 Pendentes </span>
          }
          <span class="material-symbols-outlined chevron-icon">chevron_right</span>
        </div>
      </div>
      }
      <div class="banco-card banco-card-add" (click)="adicionarConta()">
        <span class="material-symbols-outlined add-icon">add</span>
        <span class="add-label">ADICIONAR BANCO</span>
      </div>
    </div>

    @if (contasCartao.length > 0) {
    <div class="section-title mt-4">
      <mat-icon>credit_card</mat-icon>
      <span>Cartões de Crédito</span>
    </div>
    <div class="contas-grid">
      @for (conta of contasCartao; track conta.idContaFinanceira) {
      <div class="banco-card" (click)="navegarParaLancamentos(conta)">
        <div class="banco-card-logo">
          @if (conta.urlLogoBanco) {
          <img [src]="conta.urlLogoBanco" [alt]="conta.nomeBanco" class="logo-img" />
          }
          @if (!conta.urlLogoBanco) {
          <div class="logo-placeholder">
            <mat-icon>credit_card</mat-icon>
          </div>
          }
        </div>
        <div class="banco-card-info">
          <span class="banco-nome">{{ conta.nomeBanco }}</span>
          <span class="conta-descricao">{{ conta.descricao }}</span>
          <span class="conta-agencia">
            @if (conta.ultimosDigitosCartao) {
              •••• {{ conta.ultimosDigitosCartao }}
            }
            @if (conta.diaFechamentoCartao && conta.diaVencimentoCartao) {
              • Fecha {{ conta.diaFechamentoCartao }} • Vence {{ conta.diaVencimentoCartao }}
            }
          </span>
          <span class="status-badge badge-azul mt-2">Cartão</span>
        </div>
        <div class="banco-card-status">
          @if (conta.totalPendentes > 0) {
          <span class="status-badge badge-vermelho">
            {{ conta.totalPendentes }} Pendente{{ conta.totalPendentes !== 1 ? 's' : '' }}
          </span>
          }
          @if (conta.totalPendentes === 0) {
          <span class="status-badge badge-cinza"> 0 Pendentes </span>
          }
          <span class="material-symbols-outlined chevron-icon">chevron_right</span>
        </div>
      </div>
      }
    </div>
    }
    }
    }
  </div>
</div>